<template>
    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-md-0 required"> {{ $t('postal_zip_code') }} </label>
            <app-input 
                class="col-md-8" 
                type="text" 
                v-model="selected" 
                min="6"
                :placeholder="$t('postal_zip_code_phd')"  
            />
    </div>
</template>
 
<script>
    export default {
        name: 'PostalCode',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>